import universal from 'react-universal-component';

export default universal(() => import('./NotFound'));



// WEBPACK FOOTER //
// ./src/app/views/NotFound/index.js